(function($) {
	$(document).ready(function() {
		$('[data-accordion-toggle]').click(function(e) {
			e.preventDefault();
			$('.accordion').foundation('up', $(this).parent().parent());
		});
		
		var title;
		$('h4.graph-title').each(function() {
			title = $(this).html();
			title = title.replace('&lt; /&gt;4&gt;', '');
			title = title.replace('jahre', 'Jahre');
			$(this).html(title);
		});

		$('.accordion').on('down.zf.accordion', function() {
			$(".svgcontainer").each(function() {
				var chart = $(this).highcharts();
				chart.reflow();
			});
		});
	});
})(jQuery); 
